module.exports = __webpack_public_path__ + "img/shio1.2f32aacc.jpg";